<div class="form-modal">
  <div class="modal-header">
    <h4 class="modal-title">{{ confirmationContent.title }}</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">{{ confirmationContent.content }}</div>
    </div>
  </div>
  <div class="modal-footer">
    <button *ngIf="!confirmationContent.hideCancelButton" (click)="cancelModal()" class="btn btn-cancel modal-size-btn">
      {{ confirmationContent.cancelBtnText }}
    </button>
    <button *ngIf="!confirmationContent.hideSubmitButton"
      type="submit"
      (click)="onSubmitBtnClick()"
      class="btn btn-primary modal-size-btn"
    >
      {{ confirmationContent.submitBtnText }}
    </button>
  </div>
</div>
